/**
 * Utility functions for managing cookie preferences
 */

// Key for storing cookie consent in localStorage
const COOKIE_CONSENT_KEY = 'nuvola_cookie_consent';

/**
 * Check if user has already accepted cookies
 * @returns {boolean} True if cookies have been accepted
 */
export const hasCookieConsent = () => {
  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    return consent === 'true';
  } catch (error) {
    console.warn('Error accessing localStorage:', error);
    return false;
  }
};

/**
 * Set cookie consent status
 * @param {boolean} accepted - Whether cookies were accepted
 */
export const setCookieConsent = (accepted) => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, accepted.toString());
    // Store the timestamp when consent was given
    localStorage.setItem(`${COOKIE_CONSENT_KEY}_timestamp`, new Date().toISOString());
  } catch (error) {
    console.warn('Error setting cookie consent:', error);
  }
};

/**
 * Clear cookie consent (for testing or reset purposes)
 */
export const clearCookieConsent = () => {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
    localStorage.removeItem(`${COOKIE_CONSENT_KEY}_timestamp`);
  } catch (error) {
    console.warn('Error clearing cookie consent:', error);
  }
};

/**
 * Get the timestamp when consent was given
 * @returns {string|null} ISO timestamp string or null
 */
export const getConsentTimestamp = () => {
  try {
    return localStorage.getItem(`${COOKIE_CONSENT_KEY}_timestamp`);
  } catch (error) {
    console.warn('Error accessing consent timestamp:', error);
    return null;
  }
};
